function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgNzd = function SvgNzd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256C0,256.061,256,0.028,256,0 C397.384,0,512,114.616,512,256z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,0c-0.014,0-0.029,0-0.043,0H256L256,0z"
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M255.315,256H256c0-0.23,0-0.454,0-0.685C255.772,255.544,255.544,255.772,255.315,256z"
  }), React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,133.565C256,88.52,256,59.005,256,0h-0.043C114.592,0.024,0,114.629,0,256h133.565v-75.211 L208.777,256h46.539c0.228-0.228,0.457-0.456,0.685-0.685c0-17.247,0-32.636,0-46.537l-75.213-75.213H256z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M129.515,33.391C89.476,56.19,56.19,89.476,33.391,129.515V256h66.783V100.176v-0.002H256 c0-21.063,0-41.129,0-66.783H129.515z"
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,224.519l-90.953-90.953c0,0-31.481,0.002-31.481,0v0.002L255.999,256H256 C256,256,256,234.293,256,224.519z"
  }), React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "443.33,189.959 448.855,206.965 466.736,206.965 452.27,217.475 457.796,234.48  443.33,223.971 428.863,234.48 434.389,217.475 419.922,206.965 437.803,206.965  "
  }), React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "379.411,312.393 387.7,337.903 414.521,337.903 392.821,353.667 401.111,379.176  379.411,363.411 357.711,379.176 366.001,353.667 344.301,337.903 371.122,337.903  "
  }), React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "381.825,112.046 388.733,133.305 411.084,133.305 393,146.44 399.908,167.698  381.825,154.559 363.743,167.698 370.65,146.44 352.568,133.305 374.918,133.305  "
  }), React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "320.322,189.217 328.61,214.727 355.432,214.727 333.732,230.491 342.022,256  320.322,240.235 298.622,256 306.912,230.491 285.212,214.727 312.033,214.727  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNzd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NZD.9e547785.svg";
export { ForwardRef as ReactComponent };